(function(global, factory){
    if (typeof exports === 'object') {
        module.exports = factory();
    } else if ( typeof define === 'function' && define.amd ) {
        define(factory);
    }
}(this, function(){

    var taskUID = 1,
        global = this;

    function getTimestamp(){
        if ( global.performance ){
            return parseInt(global.performance.now());
        } else {
            return +(new Date());
        }
    }


    function Overseer(loopInterval){
        this._modules = {};
        this._internalLoopInterval = loopInterval || 100;
        this._intervalPointer = null;
        this._taskPool = {};
        this._poolSize = 0;
    }
    var fn = Overseer.prototype;

    fn.registerModule = function registerModule(moduleName, module){
        if ( this._isModuleRegistered(moduleName) ) {
            throw new Error('Overseer() says: "module '+moduleName+' is already registered"');
        }
        this._modules[moduleName] = {
            module: module,
            actions: {}
        };
    };

    fn.registerTask = function registerTask(moduleName, methodName, isProperty){
        var isActionTaskRegister, moduleRecord, registeredModule;
        if ( !this._isModuleRegistered(moduleName) ) {
            throw new Error('Overseer() says: "module '+moduleName+' is not registered"');
        }
        moduleRecord = this._modules[moduleName];
        registeredModule = moduleRecord.module;
        isActionTaskRegister = moduleRecord.actions[methodName] !== undefined;

        if ( isActionTaskRegister ) {
            throw new Error('Overseer() says: "task '+moduleName+'/'+methodName+' is already registered"');
        }
        if ( isProperty ){
            moduleRecord.actions[methodName] = (function (value) {
                if (value !== undefined) {
                    registeredModule[methodName] = value;
                } else {
                    return registeredModule[methodName];
                }
            }).bind(registeredModule)
        } else {
            moduleRecord.actions[methodName] = registeredModule[methodName].bind(registeredModule);
        }
    };

    fn.registerMethod = function registerMethod(methodName, method){
        if ( this._isModuleRegistered(methodName) ){
            throw new Error('Overseer() says: "module '+methodName+' is already registered"');
        }
        this._modules[methodName] = method;
    };

    fn.register = function register(moduleName, module, tasksList, propsList){
        this.registerModule(moduleName, module);
        var IS_PROP = true,
            taskName, taskIndex;
        for ( taskIndex = 0; taskIndex < tasksList.length; taskIndex++ ) {
            taskName = tasksList[taskIndex];
            this.registerTask(moduleName, taskName);
        }
        for ( taskIndex = 0; taskIndex < propsList.length; taskIndex++ ) {
            taskName = propsList[taskIndex];
            this.registerTask(moduleName, taskName, IS_PROP);
        }
    };

    /* run (t)ask */
    fn.ask = function ask(moduleName, taskName, restArgs){
        var registeredModule,
            _args = Array.prototype.slice.call(arguments, 2);

        if ( arguments.length === 1 && this._isModuleRegistered(moduleName) ) {
            return this._modules[moduleName].module;
        }

        if (!this._isTaskRegistered(moduleName, taskName)){
            throw new Error('Overseer() says: "task '+moduleName+'/'+taskName+' is not registred"');
        }
        registeredModule = this._modules[moduleName].module;
        return this._modules[moduleName].actions[taskName].apply(registeredModule,_args);
    };

    fn.askMethod = function askMethod(methodName, restArgs) {
        var registeredMethod,
            _args = Array.prototype.slice.call(arguments, 1);
        if ( 'function' !== typeof this._modules[methodName] ) {
            throw new Error('Overseer() says: "method '+methodName+' is not registred"');
        }
        return this._modules[methodName].apply(_args);
    };

    /* ask with pooling, by the gods! */
    fn.implore = function implore(moduleName, taskName, maxTimeout, restArgs) {
        var timeout = maxTimeout || false,
            _args = Array.prototype.slice.call(arguments, 3),
            argumentsAsArray = [moduleName, taskName].concat(_args);

        if ( this._isModuleRegistered(moduleName) && this._isTaskRegistered(moduleName, taskName) ) {
            /* Task is registered, so just run it */
            this.ask.apply(this, argumentsAsArray);
        } else {
            this._addInPool(argumentsAsArray, timeout);
        }

    };

    /* Remove task from pool */
    fn.cancelTask = function cancelTask(taskUID){
        if ( this._taskPool[taskUID] !== undefined ) {
            this._taskPool[taskUID] = null;
            this._decPoolSize();
        }
    };

    fn._isModuleRegistered = function _isModuleRegistered(moduleName){
        return this._modules[moduleName] !== undefined;
    };

    fn._isTaskRegistered = function _isTaskRegistered(moduleName, taskName){
        if ( !this._isModuleRegistered(moduleName) ) {
            throw new Error('Overseer() says: "module '+moduleName+' is not registered"');
        }
        return this._modules[moduleName].actions[taskName] !== undefined;
    };

    fn._addInPool = function _addInPool(args, timeout){
        var uid = taskUID++;
        this._taskPool[uid] = {
            uid: uid,
            timeout: timeout,
            registered: getTimestamp(),
            args: args
        };
        this._incPoolSize();
        return uid;
    };

    fn._tryPooledTask = function _tryPooledTask(taskUID){
        var task;
        try {
            task = this._taskPool[taskUID];
            this.ask.apply(this, task.args);
            this.cancelTask(taskUID);
            return true;
        } catch(err) {
            return false;
        }
    };

    fn._runInvoker = function _runInvoker(){
        if ( this._poolSize === 0 ) {
            clearInterval(this._intervalPointer);
            this._intervalPointer = null;
            /*
                As pool is empty, re-new object that used by task pool
                in V8 engine it will keep _taskPool object it "hot" memory
             */
            this._taskPool = {};
        } else if ( this._poolSize < 0 ) {
            //Actually possible only if _poolSize changed directly to less than zero
            console.error('Pool control is lost: pool size is less than zero!');
            clearInterval(this._intervalPointer);
            this._intervalPointer = null;
            this._repairPool();
        } else {
            this._intervalPointer = setInterval(this._invoker.bind(this), this._internalLoopInterval)
        }
    };

    fn._invoker = function _invoker(){
        var now = getTimestamp(), //It not so accurate, as on each iteration, but should be faster;
            computedPoolSize = 0,
            task, elapse, taskDone;

        for ( var taskUID in this._taskPool ){
            taskDone = false;
            if ( !this._taskPool.hasOwnProperty(taskUID) ) { continue; }
            task = this._taskPool[taskUID];
            elapse = now - task.registered;
            taskDone = this._tryPooledTask(taskUID);
            if ( !taskDone && elapse > task.timeout  ) {
                this.cancelTask(taskUID);
            } else if ( !taskDone ) {
                computedPoolSize += 1;
            }
        }

        if ( this._poolSize !== computedPoolSize ) {
            console.error('Pool control is lost: pool size is not equal computed pull size!');
            this._repairPool();
        }

    };

    fn._repairPool = function _repairPool(){
        var newPoolObject = {},
            computedPoolSize = 0;
        for ( var taskUID in this._taskPool ){
            if ( !this._taskPool.hasOwnProperty(taskUID) ) { continue; }
            if ( this._taskPool[taskUID] === null ) { continue; }
            computedPoolSize += 1;
            newPoolObject[taskUID] = this._taskPool[taskUID];
        }
        this._taskPool = newPoolObject;
        this._poolSize = computedPoolSize;
        if ( computedPoolSize ) { this._runInvoker(); }
    };

    fn._incPoolSize = function _incPoolSize(){
        this._poolSize += 1;
        this._runInvoker();
    };

    fn._decPoolSize = function _decPoolSize(){
        this._poolSize -= 1;
        this._runInvoker();
    };

    return new Overseer();

}));
